import React, { FC } from 'react'
import { useFormikContext } from 'formik'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import { DatePicker, DatePickerProps } from './DatePicker'

type Props = Omit<DatePickerProps, 'value' | 'onChange'> & {
  name: string
  onChange?: (date: Date) => void
}

export const FormDatePicker: FC<Props> = ({ name, onChange, ...restProps }) => {
  const formik = useFormikContext<Record<string, Date | string | null>>()
  const { tPrefix } = useAppTranslation('errorStatusMessage')

  const errorText = formik.errors[name]
  const value = formik.values[name] as Date | null
  const isError = Boolean(errorText)

  const handleChange = (date: Date) => {
    formik.setFieldValue(name, date)
    onChange?.(date)
  }

  const onError = (error: string) => {
    formik.setFieldError(name, error)
  }

  return (
    <DatePicker
      name={name}
      value={value}
      onChange={handleChange}
      errorText={errorText && tPrefix(errorText)}
      isError={isError}
      onError={onError}
      {...restProps}
    />
  )
}
